import React from 'react'
import ProductsPage from '../Components/ProductPage/product';

const Productspage = () => {
  return (
    <div>
        <ProductsPage></ProductsPage>
    </div>
  )
}

export default Productspage